(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden1', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-product-voices"] && !Shopify.designMode) return;
  try {
    
(function () {
  function getVariantSku(root) {
    const mapNode = root.querySelector('[data-sg-variant-map]');
    let variantMap = {};
    try { variantMap = JSON.parse(mapNode ? mapNode.textContent : '{}'); } catch (e) {}

    const url = new URL(window.location.href);
    const variantId = url.searchParams.get('variant');
    if (variantId && variantMap[variantId]) return variantMap[variantId];

    return root.dataset.initialSku || '';
  }

  function render(root) {
    const data = window.SG_PRODUCT_VOICES || {};
    const sku = getVariantSku(root);
    const entry = data[sku];
    const editorial = root.querySelector('[data-sg-editorial]');
    const grid = root.querySelector('[data-sg-voice-grid]');

    if (!editorial || !grid) return;
    grid.innerHTML = '';

    if (!entry || !Array.isArray(entry.voices) || entry.voices.length === 0) {
      editorial.hidden = true;
      return;
    }

    entry.voices.forEach(function (voice) {
      const card = document.createElement('article');
      card.className = 'sg-product-voices__card';
      const p = document.createElement('p');
      p.textContent = typeof voice === 'string' ? voice : (voice && voice.text ? voice.text : '');
      card.appendChild(p);
      grid.appendChild(card);
    });

    editorial.hidden = false;
  }

  function openJudgeMeForm(root) {
    let tries = 0;
    const maxTries = 30;

    function attempt() {
      const link = root.querySelector('.jdgm-write-rev-link, .jdgm-write-rev-link.jdgm-write-rev-link');
      if (link) {
        link.click();
        return;
      }

      tries += 1;
      if (tries < maxTries) window.setTimeout(attempt, 100);
    }

    attempt();
  }

  function init(root) {
    render(root);

    const writeButton = root.querySelector('[data-sg-write-review]');
    if (writeButton) {
      writeButton.addEventListener('click', function () {
        openJudgeMeForm(root);
      });
    }

    ['variant:change', 'product:variant-change', 'variant-change'].forEach(function (name) {
      document.addEventListener(name, function () {
        window.setTimeout(function () { render(root); }, 50);
      });
    });

    document.addEventListener('change', function (event) {
      if (event.target && event.target.closest('form[action*="/cart/add"]')) {
        window.setTimeout(function () { render(root); }, 80);
      }
    });

    window.addEventListener('popstate', function () { render(root); });
  }

  document.querySelectorAll('[data-sg-product-voices]').forEach(init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-announcementbar"] && !Shopify.designMode) return;
  try {
    
  const marqueeAnnouncement = document.querySelector('.section-marquee-announcement');
  document.documentElement.style.setProperty('--marquee-height', `${marqueeAnnouncement.offsetHeight}px`);

  } catch(e) { console.error(e); }
})();
})();
